Apt.fn.make('account.teams', {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		scope.app = Apt.fn.index().init({
			auth: true,
			view: $$('template')[0].textContent,
			path: 'account/teams',
			resource: 'me/teams',
			paginate: true
		}, () => {
			$.events.on('$teamInvite', 'click', (e, el) => {
				LS.modal.open({
					width: 360,
					model: {
						title: 'Invite user',
						content: $.view.render('account-teams.invite')
					},
					onShow: () => {
						LS.api.bind('$inviteForm', `me/teams/${el.dataset.id}/invitation`, {
							validate: true,
							namespace: 'invite',
							success: () => {
								LS.modal.close();
							}
						});
					},
					onHide: () => {
						$.events.reset('invite');
					}
				});
			}, {
				delegate: '$results',
				namespace: 'teams'
			});

			$.events.on('$teamLeave', 'click', (e, el) => {
				const $row = $(el).closest('[data-id]');
				const id = $row.data('id');

				LS.api.post(`me/teams/${id}/leave`, {
					auth: true,
					success: () => {
						$row.remove();
					}
				});
			}, {
				delegate: '$results',
				namespace: 'teams'
			});
		});

		LS.analytics.record();
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('teams', this, 'app');
	}
});